import { render, staticRenderFns } from "./member_detail.vue?vue&type=template&id=1c490518&"
import script from "./member_detail.vue?vue&type=script&lang=js&"
export * from "./member_detail.vue?vue&type=script&lang=js&"
import style0 from "./member_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports